var Q = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "Mercedes-Benz", e.MERCEDES_AMG = "Mercedes-AMG", e.MERCEDES_MAYBACH = "Mercedes-Maybach", e))(Q || {}), x = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "MERCEDES_BENZ", e.MERCEDES_AMG = "MERCEDES_AMG", e.MERCEDES_MAYBACH = "MERCEDES_MAYBACH", e.MERCEDESBENZ = "Mercedes-Benz", e.MERCEDESAMG = "Mercedes-AMG", e.MERCEDESMAYBACH = "Mercedes-Maybach", e))(x || {}), Z = /* @__PURE__ */ ((e) => (e.AMG = "amg", e.MAYBACH = "maybach", e))(Z || {}), K = /* @__PURE__ */ ((e) => (e.B2B = "B2B", e.B2C = "B2C", e.DISABLED = "DISABLED", e))(K || {}), Y;
function $(e) {
  return Y?.get(e);
}
var a;
function j(e) {
  return a?.get(e);
}
var z;
function F(e, S) {
  return z?.get(e)?.get(S);
}
function V(e) {
  const S = typeof e;
  return S === "string" ? `"${e}"` : S === "number" || S === "bigint" || S === "boolean" ? `${e}` : S === "object" || S === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : S;
}
function C(e, S, r, n, i) {
  const A = i && "input" in i ? i.input : r.value, t = i?.expected ?? e.expects ?? null, E = i?.received ?? V(A), _ = {
    kind: e.kind,
    type: e.type,
    input: A,
    expected: t,
    received: E,
    message: `Invalid ${S}: ${t ? `Expected ${t} but r` : "R"}eceived ${E}`,
    requirement: e.requirement,
    path: i?.path,
    issues: i?.issues,
    lang: n.lang,
    abortEarly: n.abortEarly,
    abortPipeEarly: n.abortPipeEarly
  }, u = e.kind === "schema", T = i?.message ?? e.message ?? F(e.reference, _.lang) ?? (u ? j(_.lang) : null) ?? n.message ?? $(_.lang);
  T && (_.message = typeof T == "function" ? (
    // @ts-expect-error
    T(_)
  ) : T), u && (r.typed = !1), r.issues ? r.issues.push(_) : r.issues = [_];
}
function b(e, S) {
  const r = [...new Set(e)];
  return r.length > 1 ? `(${r.join(` ${S} `)})` : r[0] ?? "never";
}
function R(e, S) {
  return {
    kind: "validation",
    type: "max_length",
    reference: R,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: S,
    _run(r, n) {
      return r.typed && r.value.length > this.requirement && C(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function y(e, S) {
  return {
    kind: "validation",
    type: "min_length",
    reference: y,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: S,
    _run(r, n) {
      return r.typed && r.value.length < this.requirement && C(this, "length", r, n, {
        received: `${r.value.length}`
      }), r;
    }
  };
}
function D(e, S) {
  return {
    kind: "validation",
    type: "regex",
    reference: D,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: S,
    _run(r, n) {
      return r.typed && !this.requirement.test(r.value) && C(this, "format", r, n), r;
    }
  };
}
function p(e) {
  return {
    kind: "transformation",
    type: "transform",
    reference: p,
    async: !1,
    operation: e,
    _run(S) {
      return S.value = this.operation(S.value), S;
    }
  };
}
function X(e, S, r) {
  return typeof e.fallback == "function" ? (
    // @ts-expect-error
    e.fallback(S, r)
  ) : (
    // @ts-expect-error
    e.fallback
  );
}
function w(e, S) {
  return {
    ...e,
    fallback: S,
    _run(r, n) {
      const i = e._run(r, n);
      return i.issues ? { typed: !0, value: X(this, i, n) } : i;
    }
  };
}
function J(e, S, r) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(S, r)
  ) : (
    // @ts-expect-error
    e.default
  );
}
function o(e, S) {
  return {
    kind: "schema",
    type: "array",
    reference: o,
    expects: "Array",
    async: !1,
    item: e,
    message: S,
    _run(r, n) {
      const i = r.value;
      if (Array.isArray(i)) {
        r.typed = !0, r.value = [];
        for (let A = 0; A < i.length; A++) {
          const t = i[A], E = this.item._run({ typed: !1, value: t }, n);
          if (E.issues) {
            const _ = {
              type: "array",
              origin: "value",
              input: i,
              key: A,
              value: t
            };
            for (const u of E.issues)
              u.path ? u.path.unshift(_) : u.path = [_], r.issues?.push(u);
            if (r.issues || (r.issues = E.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          E.typed || (r.typed = !1), r.value.push(E.value);
        }
      } else
        C(this, "type", r, n);
      return r;
    }
  };
}
function G(e, S) {
  if (typeof e == typeof S) {
    if (e === S || e instanceof Date && S instanceof Date && +e == +S)
      return { value: e };
    if (e && S && e.constructor === Object && S.constructor === Object) {
      for (const r in S)
        if (r in e) {
          const n = G(e[r], S[r]);
          if (n.issue)
            return n;
          e[r] = n.value;
        } else
          e[r] = S[r];
      return { value: e };
    }
    if (Array.isArray(e) && Array.isArray(S) && e.length === S.length) {
      for (let r = 0; r < e.length; r++) {
        const n = G(e[r], S[r]);
        if (n.issue)
          return n;
        e[r] = n.value;
      }
      return { value: e };
    }
  }
  return { issue: !0 };
}
function H(e, S) {
  return {
    kind: "schema",
    type: "intersect",
    reference: H,
    expects: b(
      e.map((r) => r.expects),
      "&"
    ),
    async: !1,
    options: e,
    message: S,
    _run(r, n) {
      if (this.options.length) {
        const i = r.value;
        let A;
        r.typed = !0;
        for (const t of this.options) {
          const E = t._run(
            { typed: !1, value: i },
            n
          );
          if (E.issues && (r.issues ? r.issues.push(...E.issues) : r.issues = E.issues, n.abortEarly)) {
            r.typed = !1;
            break;
          }
          E.typed || (r.typed = !1), r.typed && (A ? A.push(E.value) : A = [E.value]);
        }
        if (r.typed) {
          r.value = A[0];
          for (let t = 1; t < A.length; t++) {
            const E = G(r.value, A[t]);
            if (E.issue) {
              C(this, "type", r, n, {
                received: "unknown"
              });
              break;
            }
            r.value = E.value;
          }
        }
      } else
        C(this, "type", r, n);
      return r;
    }
  };
}
function s(e, S) {
  return {
    kind: "schema",
    type: "literal",
    reference: s,
    expects: V(e),
    async: !1,
    literal: e,
    message: S,
    _run(r, n) {
      return r.value === this.literal ? r.typed = !0 : C(this, "type", r, n), r;
    }
  };
}
function U(e, ...S) {
  const r = {
    kind: "schema",
    type: "nullish",
    reference: U,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    _run(n, i) {
      return (n.value === null || n.value === void 0) && ("default" in this && (n.value = J(
        this,
        n,
        i
      )), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped._run(n, i);
    }
  };
  return 0 in S && (r.default = S[0]), r;
}
function f(e, S) {
  return {
    kind: "schema",
    type: "object",
    reference: f,
    expects: "Object",
    async: !1,
    entries: e,
    message: S,
    _run(r, n) {
      const i = r.value;
      if (i && typeof i == "object") {
        r.typed = !0, r.value = {};
        for (const A in this.entries) {
          const t = i[A], E = this.entries[A]._run(
            { typed: !1, value: t },
            n
          );
          if (E.issues) {
            const _ = {
              type: "object",
              origin: "value",
              input: i,
              key: A,
              value: t
            };
            for (const u of E.issues)
              u.path ? u.path.unshift(_) : u.path = [_], r.issues?.push(u);
            if (r.issues || (r.issues = E.issues), n.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          E.typed || (r.typed = !1), (E.value !== void 0 || A in i) && (r.value[A] = E.value);
        }
      } else
        C(this, "type", r, n);
      return r;
    }
  };
}
function I(e) {
  return {
    kind: "schema",
    type: "string",
    reference: I,
    expects: "string",
    async: !1,
    message: e,
    _run(S, r) {
      return typeof S.value == "string" ? S.typed = !0 : C(this, "type", S, r), S;
    }
  };
}
function M(e) {
  let S;
  if (e)
    for (const r of e)
      S ? S.push(...r.issues) : S = r.issues;
  return S;
}
function c(e, S) {
  return {
    kind: "schema",
    type: "union",
    reference: c,
    expects: b(
      e.map((r) => r.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: S,
    _run(r, n) {
      let i, A, t;
      for (const E of this.options) {
        const _ = E._run(
          { typed: !1, value: r.value },
          n
        );
        if (_.typed)
          if (_.issues)
            A ? A.push(_) : A = [_];
          else {
            i = _;
            break;
          }
        else
          t ? t.push(_) : t = [_];
      }
      if (i)
        return i;
      if (A) {
        if (A.length === 1)
          return A[0];
        C(this, "type", r, n, {
          issues: M(A)
        }), r.typed = !0;
      } else {
        if (t?.length === 1)
          return t[0];
        C(this, "type", r, n, {
          issues: M(t)
        });
      }
      return r;
    }
  };
}
function g(e, S) {
  const r = {
    ...e.entries
  };
  for (const n of S)
    delete r[n];
  return { ...e, entries: r };
}
function l(...e) {
  return {
    ...e[0],
    pipe: e,
    _run(S, r) {
      for (const n of e)
        if (n.kind !== "metadata") {
          if (S.issues && (n.kind === "schema" || n.kind === "transformation")) {
            S.typed = !1;
            break;
          }
          (!S.issues || !r.abortEarly && !r.abortPipeEarly) && (S = n._run(S, r));
        }
      return S;
    }
  };
}
const L = {
  MERCEDES_BENZ: "Mercedes-Benz",
  MERCEDES_AMG: "Mercedes-AMG",
  MERCEDES_MAYBACH: "Mercedes-Maybach",
  get "Mercedes-Benz"() {
    return L.MERCEDES_BENZ;
  },
  get "Mercedes-AMG"() {
    return L.MERCEDES_AMG;
  },
  get "Mercedes-Maybach"() {
    return L.MERCEDES_MAYBACH;
  },
  get amg() {
    return L.MERCEDES_AMG;
  },
  get maybach() {
    return L.MERCEDES_MAYBACH;
  }
}, d = /^[a-zA-Z]{2}$/, W = c([l(I(), y(4), R(4)), s("")]), h = l(
  I(),
  y(2),
  R(2),
  D(d, "Must match two-letter pattern")
), P = l(
  I(),
  y(2),
  R(2),
  D(d, "Must match two-letter pattern")
), O = U(l(I(), y(3), R(5))), q = c([l(I(), y(1), R(28)), s("")]), m = w(
  c([
    s("MERCEDES_BENZ"),
    s("MERCEDES_AMG"),
    s("MERCEDES_MAYBACH"),
    s("Mercedes-Benz"),
    s("Mercedes-AMG"),
    s("Mercedes-Maybach")
  ]),
  "Mercedes-Benz"
), k = c([
  s("BODY_TYPE"),
  s("FUEL_TYPE"),
  s("PRICE"),
  s("POWER"),
  s("MODEL"),
  s("BRAND"),
  s("LINE"),
  s("COLOR_GROUP"),
  s("")
]), ee = c([
  s("ELECTRIC"),
  s("PETROL"),
  s("DIESEL"),
  s("HYBRID"),
  s("")
]), se = c([
  s("DISABLED"),
  s("CITAN"),
  s("CITAN_PANEL_VAN"),
  s("CITAN_MIXTO"),
  s("CITAN_TOURER"),
  s("MARCO_POLO"),
  s("SPRINTER"),
  s("SPRINTER_CHASSIS"),
  s("SPRINTER_CHASSIS_CREW_CAB"),
  s("SPRINTER_PANEL_VAN"),
  s("SPRINTER_TOURER"),
  s("T_CLASS"),
  s("V_CLASS"),
  s("VITO"),
  s("VITO_PANEL_VAN"),
  s("VITO_MIXTO"),
  s("VITO_TOURER"),
  s("eCITAN"),
  s("eCITAN_TOURER"),
  s("eCITAN_PANEL_VAN"),
  s("eSPRINTER"),
  s("eVITO"),
  s("eVITO_TOURER"),
  s("eVITO_PANEL_VAN"),
  s("EQT_CLASS"),
  s("EQV_CLASS")
]), re = c([
  s("DISABLED"),
  s("HATCHBACK"),
  s("LIMOUSINE"),
  s("CABRIO"),
  s("COUPE"),
  s("STATION"),
  s("SHOOTING_BRAKE"),
  s("SUV"),
  s("ROADSTER"),
  s("LONG_SEDAN"),
  s("A_CLASS"),
  s("A_CLASS_HATCHBACK"),
  s("A_CLASS_LIMOUSINE"),
  s("B_CLASS"),
  s("C_CLASS"),
  s("C_CLASS_CABRIO"),
  s("C_CLASS_COUPE"),
  s("C_CLASS_LIMOUSINE"),
  s("C_CLASS_STATION"),
  s("CLA_CLASS"),
  s("CLA_CLASS_COUPE"),
  s("CLA_CLASS_SHOOTING_BRAKE"),
  s("CLS_CLASS"),
  s("E_CLASS"),
  s("E_CLASS_STATION"),
  s("E_CLASS_CABRIO"),
  s("E_CLASS_LIMOUSINE"),
  s("EQA_CLASS"),
  s("EQB_CLASS"),
  s("EQC_CLASS"),
  s("EQE_CLASS"),
  s("EQE_CLASS_SUV"),
  s("EQE_CLASS_LIMOUSINE"),
  s("EQS_CLASS"),
  s("EQS_CLASS_SUV"),
  s("EQS_CLASS_LIMOUSINE"),
  s("G_CLASS"),
  s("GLA_CLASS"),
  s("GLB_CLASS"),
  s("GLC_CLASS"),
  s("GLC_CLASS_SUV"),
  s("GLC_CLASS_COUPE"),
  s("GLE_CLASS"),
  s("GLS_CLASS"),
  s("GT_CLASS"),
  s("S_CLASS"),
  s("S_CLASS_ROADSTER"),
  s("S_CLASS_LIMOUSINE"),
  s("S_CLASS_LONG_SEDAN"),
  s("SL_CLASS"),
  s("SLK_CLASS"),
  s("SMARTFORTWO"),
  s("X_CLASS")
]), Re = c([s("DISABLED"), s("B2C"), s("B2B")]), Se = c([
  s("A_CLASS"),
  s("B_CLASS"),
  s("C_CLASS"),
  s("CITAN"),
  s("CLA_CLASS"),
  s("CLE_CLASS"),
  s("CLS_CLASS"),
  s("E_CLASS"),
  s("EQA_CLASS"),
  s("EQB_CLASS"),
  s("EQC_CLASS"),
  s("EQE_CLASS"),
  s("EQS_CLASS"),
  s("EQT_CLASS"),
  s("EQV_CLASS"),
  s("G_CLASS"),
  s("GLA_CLASS"),
  s("GLB_CLASS"),
  s("GLC_CLASS"),
  s("GLE_CLASS"),
  s("GLS_CLASS"),
  s("GT_CLASS"),
  s("MARCO_POLO"),
  s("S_CLASS"),
  s("SL_CLASS"),
  s("SLK_CLASS"),
  s("SMARTFORTWO"),
  s("SPRINTER"),
  s("T_CLASS"),
  s("V_CLASS"),
  s("VITO"),
  s("X_CLASS")
]), ne = c([
  s("SUV"),
  s("LIMOUSINE"),
  s("PANEL_VAN"),
  s("MIXTO"),
  s("TOURER"),
  s("CHASSIS"),
  s("CHASSIS-CC"),
  s("")
]), N = (e) => Array.isArray(e) ? e.join(",") : "", ie = (e) => e.map((S) => L[S]), v = l(
  o(k),
  p((e) => N(e))
), Ae = l(
  o(ee),
  p((e) => N(e))
), Ee = l(
  o(ne),
  p((e) => N(e))
), B = l(
  o(m),
  p(ie),
  p((e) => N(e))
), te = l(
  o(Se),
  p((e) => N(e))
), ye = f({
  van: se,
  lang: h,
  market: P,
  stage: O,
  brand: B,
  clusteringCriteria: v
}), Ie = f({
  campaign: re,
  lang: h,
  market: P,
  stage: O,
  brand: B,
  enteredCampaign: q,
  clusteringCriteria: v
}), _e = f({
  baumuster4: W,
  lang: h,
  market: P,
  stage: O,
  brand: B,
  bodyType: Ee,
  clusteringCriteria: v,
  fuelTypes: Ae
}), Ne = H([
  g(_e, ["baumuster4"]),
  f({ modelIdentifier: te })
]), ue = f({
  lang: h,
  market: P,
  stage: O,
  brand: o(m)
}), Te = f({
  ...ue.entries,
  ...f({ brand: o(m) }).entries
});
var Ce = /* @__PURE__ */ ((e) => (e.PRIVATE = "private", e.BUSINESS = "business", e.NONE = "none", e.EMPTY = "", e))(Ce || {});
const he = ["PC", "VAN", "VAN_PRIVATE", "VAN_COMMERCIAL"];
var ce = /* @__PURE__ */ ((e) => (e.AT = "AT", e.AU = "AU", e.BE = "BE", e.BG = "BG", e.BR = "BR", e.CA = "CA", e.CH = "CH", e.CN = "CN", e.CY = "CY", e.CZ = "CZ", e.DE = "DE", e.DK = "DK", e.EE = "EE", e.ES = "ES", e.FI = "FI", e.FR = "FR", e.GB = "GB", e.GR = "GR", e.HK = "HK", e.HR = "HR", e.HU = "HU", e.IE = "IE", e.IN = "IN", e.IT = "IT", e.JP = "JP", e.KR = "KR", e.LI = "LI", e.LT = "LT", e.LU = "LU", e.LV = "LV", e.MO = "MO", e.MT = "MT", e.MX = "MX", e.MY = "MY", e.NL = "NL", e.NO = "NO", e.NZ = "NZ", e.PL = "PL", e.PT = "PT", e.RO = "RO", e.RU = "RU", e.SE = "SE", e.SG = "SG", e.SI = "SI", e.SK = "SK", e.TH = "TH", e.TR = "TR", e.TW = "TW", e.US = "US", e.VN = "VN", e.ZA = "ZA", e))(ce || {}), le = /* @__PURE__ */ ((e) => (e.bg = "bg", e.cs = "cs", e.da = "da", e.de = "de", e.el = "el", e.en = "en", e.es = "es", e.et = "et", e.fi = "fi", e.fr = "fr", e.hr = "hr", e.hu = "hu", e.it = "it", e.ja = "ja", e.ko = "ko", e.lv = "lv", e.nl = "nl", e.pl = "pl", e.pt = "pt", e.ro = "ro", e.ru = "ru", e.sk = "sk", e.sl = "sl", e.sv = "sv", e.th = "th", e.tr = "tr", e.zh = "zh", e.zs = "zs", e))(le || {}), fe = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.DEV = "DEV", e.TEST = "TEST", e.INT = "INT", e.PPROD = "PPROD", e.PROD = "PROD", e.STANDALONE = "STANDALONE", e))(fe || {}), oe = /* @__PURE__ */ ((e) => (e.PI_PAGES_CARS = "PI_PAGES_CARS", e.PI_PAGES_VANS = "PI_PAGES_VANS", e.HOMEPAGE_CARS = "HOMEPAGE_CARS", e.HOMEPAGE_VANS = "HOMEPAGE_VANS", e.CAMPAIGN_TEASER_CARS = "CAMPAIGN_TEASER_CARS", e.CAMPAIGN_TEASER_VANS = "CAMPAIGN_TEASER_VANS", e.SIMPLE_PRICE = "SIMPLE_PRICE", e.ZERO_RESULT = "ZERO_RESULT", e))(oe || {}), pe = /* @__PURE__ */ ((e) => (e.PI_PAGES_CARS = "PI_PAGES_CARS", e.PI_PAGES_VANS = "PI_PAGES_VANS", e.HOMEPAGE_CARS = "HOMEPAGE_CARS", e.HOMEPAGE_VANS = "HOMEPAGE_VANS", e.CAMPAIGN_TEASER_CARS = "CAMPAIGN_TEASER_CARS", e.CAMPAIGN_TEASER_VANS = "CAMPAIGN_TEASER_VANS", e.SIMPLE_PRICE = "SIMPLE_PRICE", e.ZERO_RESULT = "ZERO_RESULT", e.BANNER_CAMPAIGN = "BANNER_CAMPAIGN", e.PERSONALIZED_T4 = "T4", e.VEHICLE_MATCH_TEASER = "VEHICLE_MATCH_TEASER", e))(pe || {}), Le = /* @__PURE__ */ ((e) => (e.LIGHT = "light", e.DARK = "dark", e))(Le || {});
export {
  Q as Brand,
  Ce as CUSTOMER_TYPE,
  K as Context,
  pe as InflateRequestMode,
  le as Language,
  ce as Market,
  oe as OneTeaserMode,
  x as OneWebBrand,
  Z as OneWebEnvBrand,
  ue as SmartTeaserQuerySchema,
  Te as SmartTeaserQuerySchemaExtended,
  fe as StageEnum,
  _e as TeaserSearchSchema,
  Ie as TeaserSearchSchemaCampaign,
  Ne as TeaserSearchSchemaGeneric,
  ye as TeaserSearchSchemaVans,
  Le as WorkbenchTheme,
  he as configurationProductProductGroup,
  h as lang,
  P as market,
  te as modelIdentifierEnums,
  W as schemaBaumuster4,
  ne as validBodyTypes,
  m as validBrands,
  Se as validClassEnums,
  k as validClusteringCriteria,
  Re as validCtxEnums,
  ee as validFuelTypes,
  re as validPkwEnums,
  se as validVansEnums
};
//# sourceMappingURL=index.js.map
